import axios from 'axios'
import { REACT_APP_API } from '../../config';

const QUALITY_RATING_MAP = {
    GREEN: 'alta',
    YELLOW: 'media',
    RED: 'baja'
}

export async function getWhatsAppLines() {
    try {
        const { data } = await axios.get(`${REACT_APP_API}/abms/whatsapp-lines/`)
        return data.map(line => ({
            ...line,
            quality: QUALITY_RATING_MAP[line.qualityRating] ?? line.quality
        }))
    } catch (error) {
        throw new Error(error)
    }
}
